/**
 * The languages the application ships translations for.
 *
 * Romanian is the source of truth: every key's `ro` value is the original
 * text, and any language may lag behind it but never introduces a key `ro`
 * does not have (enforced by `scripts/i18n/check-i18n.mjs`). The set grows as
 * catalogs are added; a clinic only sees the ones the platform grants it
 * (`tenants.yaml` `languages:`) and then enables (`org_config.i18n`).
 */
export const SUPPORTED_LANGS = ['ro', 'ru', 'en', 'he'] as const;

export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

/** The language every other one falls back to, and the source of truth. */
export const FALLBACK_LANG: SupportedLang = 'ro';

/** Each language named in itself, for the language switcher. */
export const LANG_LABELS: Record<string, string> = {
  ro: 'Română',
  ru: 'Русский',
  en: 'English',
  he: 'עברית',
};
